<template>
  <div class="cashier-state-screen">
    <div class="cashier-state-shell">
      <div class="cashier-state-card cashier-state-card--loading cashier-state-card--compact">
        <div class="cashier-state-mark">
          <span class="cashier-state-spinner"></span>
        </div>
        <div class="cashier-state-eyebrow">身份校验</div>
        <h1 class="cashier-state-title">正在校验支付身份</h1>
        <div class="cashier-state-copy">支付授权已返回，正在完成身份确认并继续跳转。</div>
      </div>
    </div>
  </div>
</template>

<script>

import {getChannelUserId} from '@/api/api'
import wayCodeUtils from '@/utils/wayCode'
import channelUserIdUtil from '@/utils/channelUserId'
import config from "@/config";
export default {
  components: {
  },
  mounted() {


    const allQuery = Object.assign({}, this.searchToObject(), this.$route.query)

    const that = this;
    getChannelUserId(allQuery).then(res => {

      //设置channelUserId
      channelUserIdUtil.setChannelUserId(res);

      this.$router.push({name: wayCodeUtils.getPayWay().routeName})
    }).catch(res => {
      that.$router.push({name: config.errorPageRouteName, params: {errInfo: res.msg}})
    });

  },
  methods: {

    searchToObject: function() {

      if(!window.location.search){
        return {};
      }

      var pairs = window.location.search.substring(1).split("&"),
          result = {},
          pair,
          i;
      for ( i in pairs ) {
        if ( pairs[i] === "" ) continue;
        pair = pairs[i].split("=");
        result[ decodeURIComponent( pair[0] ) ] = decodeURIComponent( pair[1] );
      }
      return result;
    }

  }
}
</script>

<style scoped>
@import './cashier-desktop.css';
</style>
